/* eslint-disable */  
/// <reference path="./custom.d.ts" />
// tslint:disable
// @ts-nocheck
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8088".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AdMarkupBean
 */
export interface AdMarkupBean {
    /**
     * 
     * @type {number}
     * @memberof AdMarkupBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdMarkupBean
     */
    bundleId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupBean
     */
    bundleName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupBean
     */
    campaignType?: AdMarkupBean.CampaignTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupBean
     */
    countryIso3?: string;
    /**
     * 
     * @type {number}
     * @memberof AdMarkupBean
     */
    markupPercent?: number;
}

/**
 * @export
 * @namespace AdMarkupBean
 */
export namespace AdMarkupBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CampaignTypeEnum {
        Lat = <any> 'Lat',
        Ua = <any> 'Ua',
        Rt = <any> 'Rt'
    }
}
/**
 * 
 * @export
 * @interface AdMarkupLimitBean
 */
export interface AdMarkupLimitBean {
    /**
     * 
     * @type {number}
     * @memberof AdMarkupLimitBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdMarkupLimitBean
     */
    bundleId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupLimitBean
     */
    bundleName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupLimitBean
     */
    campaignType?: AdMarkupLimitBean.CampaignTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdMarkupLimitBean
     */
    countryIso3?: string;
    /**
     * 
     * @type {number}
     * @memberof AdMarkupLimitBean
     */
    markupPercent?: number;
}

/**
 * @export
 * @namespace AdMarkupLimitBean
 */
export namespace AdMarkupLimitBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CampaignTypeEnum {
        Lat = <any> 'Lat',
        Ua = <any> 'Ua',
        Rt = <any> 'Rt'
    }
}
/**
 * 
 * @export
 * @interface AdvAdMarkupLimit
 */
export interface AdvAdMarkupLimit {
    /**
     * 
     * @type {number}
     * @memberof AdvAdMarkupLimit
     */
    globalLimit?: number;
    /**
     * 
     * @type {Array<AdMarkupLimitBean>}
     * @memberof AdvAdMarkupLimit
     */
    limits?: Array<AdMarkupLimitBean>;
}
/**
 * 
 * @export
 * @interface AdvertiserAudienceFileBean
 */
export interface AdvertiserAudienceFileBean {
    /**
     * 
     * @type {string}
     * @memberof AdvertiserAudienceFileBean
     */
    advertiserAudienceType?: AdvertiserAudienceFileBean.AdvertiserAudienceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserAudienceFileBean
     */
    bundleId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserAudienceFileBean
     */
    audienceName?: string;
}

/**
 * @export
 * @namespace AdvertiserAudienceFileBean
 */
export namespace AdvertiserAudienceFileBean {
    /**
     * @export
     * @enum {string}
     */
    export enum AdvertiserAudienceTypeEnum {
        SuppressionList = <any> 'SuppressionList',
        SeedList = <any> 'SeedList',
        RetargetingAudience = <any> 'RetargetingAudience'
    }
}
/**
 * 
 * @export
 * @interface AdvertiserBundleInfoBean
 */
export interface AdvertiserBundleInfoBean {
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBundleInfoBean
     */
    bundleId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBundleInfoBean
     */
    bundleName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBundleInfoBean
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBundleInfoBean
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBundleInfoBean
     */
    osType?: AdvertiserBundleInfoBean.OsTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvertiserBundleInfoBean
     */
    targetAppEvents?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBundleInfoBean
     */
    revenueLast7Days?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserBundleInfoBean
     */
    funnel?: boolean;
}

/**
 * @export
 * @namespace AdvertiserBundleInfoBean
 */
export namespace AdvertiserBundleInfoBean {
    /**
     * @export
     * @enum {string}
     */
    export enum OsTypeEnum {
        Android = <any> 'Android',
        IOS = <any> 'IOS'
    }
}
/**
 * 
 * @export
 * @interface AdvertiserOptionBean
 */
export interface AdvertiserOptionBean {
    /**
     * 0 for the Unassigned option, which groups the account's apps that have no advertiser
     * @type {number}
     * @memberof AdvertiserOptionBean
     */
    accountAdvertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserOptionBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserOptionBean
     */
    bundlesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserOptionBean
     */
    campaignsCount?: number;
}
/**
 * 
 * @export
 * @interface AppEventColumnInfo
 */
export interface AppEventColumnInfo {
    /**
     * 
     * @type {string}
     * @memberof AppEventColumnInfo
     */
    headerName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppEventColumnInfo
     */
    cohortEventToken?: string;
    /**
     * 
     * @type {string}
     * @memberof AppEventColumnInfo
     */
    valueType?: AppEventColumnInfo.ValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AppEventColumnInfo
     */
    cohortDay?: number;
    /**
     * 
     * @type {string}
     * @memberof AppEventColumnInfo
     */
    sqlAlias?: string;
}

/**
 * @export
 * @namespace AppEventColumnInfo
 */
export namespace AppEventColumnInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum ValueTypeEnum {
        Count = <any> 'Count',
        Sum = <any> 'Sum',
        CohortRetention = <any> 'CohortRetention',
        CohortRoas = <any> 'CohortRoas',
        CohortEvent = <any> 'CohortEvent',
        CohortRoasCustom = <any> 'CohortRoasCustom',
        CohortEventUnique = <any> 'CohortEventUnique',
        CohortEventToken = <any> 'CohortEventToken'
    }
}
/**
 * 
 * @export
 * @interface BundleIntegrationBean
 */
export interface BundleIntegrationBean {
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    bundleName?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    costMmp?: BundleIntegrationBean.CostMmpEnum;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    costAdvertiserId?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    costAdvertiserApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    audienceMmp?: BundleIntegrationBean.AudienceMmpEnum;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    audienceIntegrationApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    mparticleApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleIntegrationBean
     */
    mparticleClientId?: string;
}

/**
 * @export
 * @namespace BundleIntegrationBean
 */
export namespace BundleIntegrationBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CostMmpEnum {
        Appsflyer = <any> 'Appsflyer',
        Adjust = <any> 'Adjust',
        Branch = <any> 'Branch',
        Singular = <any> 'Singular',
        MyTracker = <any> 'MyTracker',
        Kochava = <any> 'Kochava',
        Tenjin = <any> 'Tenjin',
        Airbridge = <any> 'Airbridge',
        JustTrack = <any> 'JustTrack',
        Adbrix = <any> 'Adbrix'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AudienceMmpEnum {
        Appsflyer = <any> 'Appsflyer',
        Adjust = <any> 'Adjust',
        Branch = <any> 'Branch',
        Singular = <any> 'Singular',
        MyTracker = <any> 'MyTracker',
        Kochava = <any> 'Kochava',
        Tenjin = <any> 'Tenjin',
        Airbridge = <any> 'Airbridge',
        JustTrack = <any> 'JustTrack',
        Adbrix = <any> 'Adbrix'
    }
}
/**
 * 
 * @export
 * @interface ChangePasswordBean
 */
export interface ChangePasswordBean {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBean
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBean
     */
    passwordConfirm?: string;
}
/**
 * 
 * @export
 * @interface CountryBean
 */
export interface CountryBean {
    /**
     * 
     * @type {number}
     * @memberof CountryBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    iso3?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    iso2?: string;
}
/**
 * 
 * @export
 * @interface CreativeResultBean
 */
export interface CreativeResultBean {
    /**
     * 
     * @type {Array<CreativeResultRowBean>}
     * @memberof CreativeResultBean
     */
    rows?: Array<CreativeResultRowBean>;
    /**
     * 
     * @type {CreativeResultRowBean}
     * @memberof CreativeResultBean
     */
    total?: CreativeResultRowBean;
    /**
     * 
     * @type {Array<AppEventColumnInfo>}
     * @memberof CreativeResultBean
     */
    appEventColumnInfo?: Array<AppEventColumnInfo>;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultBean
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultBean
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultBean
     */
    totalRecords?: number;
}
/**
 * 
 * @export
 * @interface CreativeResultRowBean
 */
export interface CreativeResultRowBean {
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    impr?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    click?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    install?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    conversions?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    reInstall?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    reEngagementInstall?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    installRate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    cvr?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    spend?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    spendOverall?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    revenue?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    cpi?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    cpr?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    ipm?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    rpm?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    cpm?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    cpc?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    revEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    firstPurchase?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    ftd?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    ftdUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    roas?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreativeResultRowBean
     */
    appEvents?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    day?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    creativeTemplateTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    creativeTag?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    creativeType?: CreativeResultRowBean.CreativeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    creativeId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    creativeTemplateDuration?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeResultRowBean
     */
    creativeFilters?: Array<CreativeResultRowBean.CreativeFiltersEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeResultRowBean
     */
    mappingCreativeName?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    nativeTemplateType?: CreativeResultRowBean.NativeTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    iconUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    nativeTitleTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    nativeCtaTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeResultRowBean
     */
    nativeDescTemplate?: string;
    /**
     * Combinations that ran with this asset (end card / rewarded for video, copy for native); absent on child rows and on flat rows
     * @type {Array<CreativeResultRowBean>}
     * @memberof CreativeResultRowBean
     */
    children?: Array<CreativeResultRowBean>;
    /**
     * 
     * @type {number}
     * @memberof CreativeResultRowBean
     */
    variantCount?: number;
}

/**
 * @export
 * @namespace CreativeResultRowBean
 */
export namespace CreativeResultRowBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CreativeTypeEnum {
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        Native = <any> 'Native'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CreativeFiltersEnum {
        Portrait = <any> 'Portrait',
        Landscape = <any> 'Landscape',
        Square = <any> 'Square',
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Rewarded = <any> 'Rewarded',
        Playable = <any> 'Playable',
        EndCard = <any> 'EndCard'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeTemplateTypeEnum {
        Icon = <any> 'Icon',
        Video = <any> 'Video',
        Image = <any> 'Image'
    }
}
/**
 * 
 * @export
 * @interface DashboardReportBean
 */
export interface DashboardReportBean {
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    mode?: DashboardReportBean.ModeEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    os?: DashboardReportBean.OsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardReportBean
     */
    creativeFilters?: Array<DashboardReportBean.CreativeFiltersEnum>;
    /**
     * 
     * @type {DateRangeOptionsBean}
     * @memberof DashboardReportBean
     */
    dateRange?: DateRangeOptionsBean;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    countryIso3?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    bundleId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardReportBean
     */
    groupBy?: Array<DashboardReportBean.GroupByEnum>;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    selectedCampaignType?: DashboardReportBean.SelectedCampaignTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    selectedChannelType?: DashboardReportBean.SelectedChannelTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardReportBean
     */
    haveAudiencesWithControlGroup?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardReportBean
     */
    tagFilter?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    targetEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardReportBean
     */
    creativeGroupBy?: DashboardReportBean.CreativeGroupByEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardReportBean
     */
    skanRequest?: boolean;
}

/**
 * @export
 * @namespace DashboardReportBean
 */
export namespace DashboardReportBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        CAMPAIGNBUNDLES = <any> 'CAMPAIGN_BUNDLES',
        PLACEMENTBUNDLES = <any> 'PLACEMENT_BUNDLES',
        CREATIVETEMPLATES = <any> 'CREATIVE_TEMPLATES',
        NATIVETEMPLATES = <any> 'NATIVE_TEMPLATES'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OsEnum {
        Android = <any> 'Android',
        IOS = <any> 'IOS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CreativeFiltersEnum {
        Portrait = <any> 'Portrait',
        Landscape = <any> 'Landscape',
        Square = <any> 'Square',
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Rewarded = <any> 'Rewarded',
        Playable = <any> 'Playable',
        EndCard = <any> 'EndCard'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum GroupByEnum {
        Cid = <any> 'cid',
        Crid = <any> 'crid',
        DeviceAgeWeeks = <any> 'deviceAgeWeeks',
        DeviceAgeDays = <any> 'deviceAgeDays',
        SessionDepth = <any> 'sessionDepth',
        WaterfallPosition = <any> 'waterfallPosition',
        Day = <any> 'day',
        MlBidEventCtfixedRegDay = <any> 'mlBidEventCtfixedRegDay',
        Hour = <any> 'hour',
        Sspid = <any> 'sspid',
        Siteid = <any> 'siteid',
        Placementid = <any> 'placementid',
        Placementname = <any> 'placementname',
        Width = <any> 'width',
        Height = <any> 'height',
        Osversion = <any> 'osversion',
        OsversionNormalized = <any> 'osversionNormalized',
        Osversion1 = <any> 'osversion1',
        Osvbase = <any> 'osvbase',
        Mraid = <any> 'mraid',
        Banner = <any> 'banner',
        Video = <any> 'video',
        Nnative = <any> 'nnative',
        Bundle = <any> 'bundle',
        Storeurl = <any> 'storeurl',
        Bidder = <any> 'bidder',
        Rewarded = <any> 'rewarded',
        Vast1 = <any> 'vast1',
        Vast2 = <any> 'vast2',
        Vast3 = <any> 'vast3',
        Vast1wrapper = <any> 'vast1wrapper',
        Vast2wrapper = <any> 'vast2wrapper',
        Vast3wrapper = <any> 'vast3wrapper',
        Vast4 = <any> 'vast4',
        Vast4wrapper = <any> 'vast4wrapper',
        Daast1 = <any> 'daast1',
        Daast1wrapper = <any> 'daast1wrapper',
        AvgWinPriceRange = <any> 'avgWinPriceRange',
        FraudlogixScore = <any> 'fraudlogixScore',
        NoBidReason = <any> 'noBidReason',
        NativeIconHMin = <any> 'nativeIconHMin',
        NativeIconWMin = <any> 'nativeIconWMin',
        NativeIconH = <any> 'nativeIconH',
        NativeIconW = <any> 'nativeIconW',
        NativeImgHMin = <any> 'nativeImgHMin',
        NativeImgWMin = <any> 'nativeImgWMin',
        NativeImgH = <any> 'nativeImgH',
        NativeImgW = <any> 'nativeImgW',
        NativeTitleLength = <any> 'nativeTitleLength',
        NativeVast1 = <any> 'nativeVast1',
        NativeVast2 = <any> 'nativeVast2',
        NativeVast3 = <any> 'nativeVast3',
        NativeVast4 = <any> 'nativeVast4',
        NativeVast1wrapper = <any> 'nativeVast1wrapper',
        NativeVast2wrapper = <any> 'nativeVast2wrapper',
        NativeVast3wrapper = <any> 'nativeVast3wrapper',
        NativeVast4wrapper = <any> 'nativeVast4wrapper',
        NativeDaast1 = <any> 'nativeDaast1',
        NativeDaast1wrapper = <any> 'nativeDaast1wrapper',
        Cluster = <any> 'cluster',
        Make = <any> 'make',
        Model = <any> 'model',
        ModelSource = <any> 'modelSource',
        Isp = <any> 'isp',
        DevH = <any> 'devH',
        DevW = <any> 'devW',
        State = <any> 'state',
        Region = <any> 'region',
        City = <any> 'city',
        BidRtSegments = <any> 'bidRtSegments',
        Retention = <any> 'retention',
        CompanionStaticResource = <any> 'companionStaticResource',
        CompanionHtmlResource = <any> 'companionHtmlResource',
        CompanionIframeResource = <any> 'companionIframeResource',
        WeekDay = <any> 'weekDay',
        WeekDayUser = <any> 'weekDayUser',
        UaDeviceType = <any> 'uaDeviceType',
        UaBatteryCapacity = <any> 'uaBatteryCapacity',
        UaDeviceRAM = <any> 'uaDeviceRAM',
        UaReleaseYear = <any> 'uaReleaseYear',
        UaMaxInternalStorage = <any> 'uaMaxInternalStorage',
        UaScreenPixelsWidth = <any> 'uaScreenPixelsWidth',
        UaScreenPixelsHeight = <any> 'uaScreenPixelsHeight',
        UaScreenInchesDiagonal = <any> 'uaScreenInchesDiagonal',
        Ppi = <any> 'ppi',
        IgnoreReason = <any> 'ignoreReason',
        DisplayManager = <any> 'displayManager',
        DisplayManagerVer = <any> 'displayManagerVer',
        Ssps = <any> 'ssps',
        Apps = <any> 'apps',
        BundleTotalFc = <any> 'bundleTotalFc',
        BundleDailyFc = <any> 'bundleDailyFc',
        NativeVpaid1 = <any> 'nativeVpaid1',
        NativeVpaid2 = <any> 'nativeVpaid2',
        NativeMraid1 = <any> 'nativeMraid1',
        NativeMraid2 = <any> 'nativeMraid2',
        NativeMraid3 = <any> 'nativeMraid3',
        NativeOrmma = <any> 'nativeOrmma',
        BannerVpaid1 = <any> 'bannerVpaid1',
        BannerVpaid2 = <any> 'bannerVpaid2',
        BannerMraid1 = <any> 'bannerMraid1',
        BannerMraid2 = <any> 'bannerMraid2',
        BannerMraid3 = <any> 'bannerMraid3',
        BannerOrmma = <any> 'bannerOrmma',
        VideoVpaid1 = <any> 'videoVpaid1',
        VideoVpaid2 = <any> 'videoVpaid2',
        VideoMraid1 = <any> 'videoMraid1',
        VideoMraid2 = <any> 'videoMraid2',
        VideoMraid3 = <any> 'videoMraid3',
        VideoOrmma = <any> 'videoOrmma',
        DevLang = <any> 'devLang',
        GeoOffset = <any> 'geoOffset',
        AgeBucket = <any> 'ageBucket',
        Gender = <any> 'gender',
        UserHour = <any> 'userHour',
        UserOffset = <any> 'userOffset',
        ImpDepthBucketId = <any> 'impDepthBucketId',
        Clicker = <any> 'clicker',
        IosBuildId = <any> 'iosBuildId',
        Instl = <any> 'instl',
        PmmlProbability = <any> 'pmmlProbability',
        SecondaryPrediction = <any> 'secondaryPrediction',
        MultiProb = <any> 'multiProb',
        MatchScore = <any> 'matchScore',
        ImgFormat = <any> 'imgFormat',
        ImgName = <any> 'imgName',
        ImgOrientation = <any> 'imgOrientation',
        ImgSize = <any> 'imgSize',
        CompanionFormat = <any> 'companionFormat',
        CompanionName = <any> 'companionName',
        CompanionOrientation = <any> 'companionOrientation',
        CompanionSize = <any> 'companionSize',
        VideoBitrate = <any> 'videoBitrate',
        VideoDuration = <any> 'videoDuration',
        VideoName = <any> 'videoName',
        VideoOrientation = <any> 'videoOrientation',
        VideoSize = <any> 'videoSize',
        AuctionType = <any> 'auctionType',
        SegmentIds = <any> 'segmentIds',
        SegmentIdsSplitted = <any> 'segmentIdsSplitted',
        AvgInstlWinPrice = <any> 'avgInstlWinPrice',
        AvgBannerWinPrice = <any> 'avgBannerWinPrice',
        AvgNativeWinPrice = <any> 'avgNativeWinPrice',
        DealIds = <any> 'dealIds',
        DealIdsSplitted = <any> 'dealIdsSplitted',
        UpdatedAppVersionBool = <any> 'updatedAppVersionBool',
        NetspeedShort = <any> 'netspeedShort',
        DeviceTypeShort = <any> 'deviceTypeShort',
        BidfloorrangeLeftBound = <any> 'bidfloorrangeLeftBound',
        ConnectiontypeShort = <any> 'connectiontypeShort',
        CountryFull = <any> 'countryFull',
        Payer = <any> 'payer',
        Os = <any> 'os',
        LmtValue = <any> 'lmtValue',
        Lmt = <any> 'lmt',
        BundleInterstitialDailyFC = <any> 'bundleInterstitialDailyFC',
        BundleInterstitialTotalFC = <any> 'bundleInterstitialTotalFC',
        BundleNativeDailyFC = <any> 'bundleNativeDailyFC',
        BundleNativeTotalFC = <any> 'bundleNativeTotalFC',
        BundleBannerDailyFC = <any> 'bundleBannerDailyFC',
        BundleBannerTotalFC = <any> 'bundleBannerTotalFC',
        DeviceCost = <any> 'deviceCost',
        BiddingLogic = <any> 'biddingLogic',
        LossCode = <any> 'lossCode',
        Month = <any> 'month',
        UserCategoryWeeklyRequests = <any> 'userCategoryWeeklyRequests',
        GpsPresented = <any> 'gpsPresented',
        PmmlProbabilityExactPercents = <any> 'pmmlProbabilityExactPercents',
        HadImpression = <any> 'hadImpression',
        UserClearRatePercents = <any> 'userClearRatePercents',
        AvgInstlBidPrice = <any> 'avgInstlBidPrice',
        AvgBannerBidPrice = <any> 'avgBannerBidPrice',
        AvgNativeBidPrice = <any> 'avgNativeBidPrice',
        AudienceIdsSplitted = <any> 'audienceIdsSplitted',
        GpsResolved = <any> 'gpsResolved',
        GeoLocationMethod = <any> 'geoLocationMethod',
        LocationGroup = <any> 'locationGroup',
        ZipCodeType = <any> 'zipCodeType',
        PricingAgentName = <any> 'pricingAgentName',
        PricingAgentFormula = <any> 'pricingAgentFormula',
        AppEventUserId = <any> 'appEventUserId',
        AppEventIsTarget = <any> 'appEventIsTarget',
        UserTotalImprs = <any> 'userTotalImprs',
        UserTotalInstalls = <any> 'userTotalInstalls',
        PmmlModelName = <any> 'pmmlModelName',
        SecondaryModelName = <any> 'secondaryModelName',
        ActiveHourClusterId = <any> 'activeHourClusterId',
        PacingTypeId = <any> 'pacingTypeId',
        MedianHhi = <any> 'medianHhi',
        MajorityEthnicity = <any> 'majorityEthnicity',
        PmmlRtpm = <any> 'pmmlRtpm',
        LastHourRequestsGrouped = <any> 'lastHourRequestsGrouped',
        Last24HoursUniqueBundlesGrouped = <any> 'last24HoursUniqueBundlesGrouped',
        ActiveHours7DaysRange = <any> 'activeHours7DaysRange',
        DailyRequestsBucketId = <any> 'dailyRequestsBucketId',
        Last7DaysUniqueBundlesRange = <any> 'last7DaysUniqueBundlesRange',
        UniqueDaysInApp = <any> 'uniqueDaysInApp',
        MaleProbaPredicted = <any> 'maleProbaPredicted',
        AgeProba0 = <any> 'ageProba0',
        AgeProba1 = <any> 'ageProba1',
        AgeProba2 = <any> 'ageProba2',
        AgeClass = <any> 'ageClass',
        UserCBundleDot = <any> 'userCBundleDot',
        BundlesCosine = <any> 'bundlesCosine',
        CfVectorType = <any> 'cfVectorType',
        AppsInstalledLast24Hours = <any> 'appsInstalledLast24Hours',
        AppsInstalledLast72Hours = <any> 'appsInstalledLast72Hours',
        W2vBundleDistanceRange = <any> 'w2vBundleDistanceRange',
        ElmoBundleDistanceRange = <any> 'elmoBundleDistanceRange',
        Last7DaysGamesPlayedRange = <any> 'last7DaysGamesPlayedRange',
        Last24HoursGamesPlayedRange = <any> 'last24HoursGamesPlayedRange',
        OpenRtbVersion = <any> 'openRtbVersion',
        CridSelectionStrategyId = <any> 'cridSelectionStrategyId',
        CridSelectionBreakdown = <any> 'cridSelectionBreakdown',
        CampaignTags = <any> 'campaignTags',
        PlacementBundleLdaTopic = <any> 'placementBundleLdaTopic',
        MatchScoreExact = <any> 'matchScoreExact',
        NativeVersion = <any> 'nativeVersion',
        NativeCtaRequired = <any> 'nativeCtaRequired',
        NativeCtaLength = <any> 'nativeCtaLength',
        NativeDescriptionRequired = <any> 'nativeDescriptionRequired',
        NativeDescriptionLength = <any> 'nativeDescriptionLength',
        NativeRatingRequired = <any> 'nativeRatingRequired',
        NativeRatingLength = <any> 'nativeRatingLength',
        NativeSponsoredRequired = <any> 'nativeSponsoredRequired',
        NativeSponsoredLength = <any> 'nativeSponsoredLength',
        NativeVideoAvailable = <any> 'nativeVideoAvailable',
        NativeVideoRequired = <any> 'nativeVideoRequired',
        NativeStyleId = <any> 'nativeStyleId',
        NativeStyleWidth = <any> 'nativeStyleWidth',
        NativeStyleHeight = <any> 'nativeStyleHeight',
        NativeEventtrackers = <any> 'nativeEventtrackers',
        ChannelType = <any> 'channelType',
        TagId = <any> 'tagId',
        PredictionStageCampaigns = <any> 'predictionStageCampaigns',
        PredictionStageBundles = <any> 'predictionStageBundles',
        AdoptionRateGrouped = <any> 'adoptionRateGrouped',
        CBundle = <any> 'cBundle',
        HaveIdfv = <any> 'haveIdfv',
        PricingAgentType = <any> 'pricingAgentType',
        Organic = <any> 'organic',
        CampaignType = <any> 'campaignType',
        CampaignChannelType = <any> 'campaignChannelType',
        CampaignTypeColumn = <any> 'campaignTypeColumn',
        Skadn = <any> 'skadn',
        SkadnVersion = <any> 'skadnVersion',
        SkanRetargeting = <any> 'skanRetargeting',
        TrackingId = <any> 'trackingId',
        FirstPredictionCp = <any> 'firstPredictionCp',
        SecondaryPredictionCp = <any> 'secondaryPredictionCp',
        LimitedAdTracking = <any> 'limitedAdTracking',
        BidTypeId = <any> 'bidTypeId',
        HadBidFloor = <any> 'hadBidFloor',
        BidFloorBucket = <any> 'bidFloorBucket',
        BannerPos = <any> 'bannerPos',
        SkanParameterArray = <any> 'skanParameterArray',
        SkanParameterArraySplitted = <any> 'skanParameterArraySplitted',
        SkanCid = <any> 'skanCid',
        SkanConversionValue = <any> 'skanConversionValue',
        CrType = <any> 'crType',
        BidPricePreShading = <any> 'bidPricePreShading',
        ShadingOpportunity = <any> 'shadingOpportunity',
        InterstitialIdfvFc = <any> 'interstitialIdfvFc',
        NativeIdfvFc = <any> 'nativeIdfvFc',
        BannerIdfvFc = <any> 'bannerIdfvFc',
        GlobalModelBranch = <any> 'globalModelBranch',
        BidPriceCalcSource = <any> 'bidPriceCalcSource',
        UnityFeatureFlag = <any> 'unityFeatureFlag',
        IsLat = <any> 'isLat',
        Currency = <any> 'currency',
        CBundleGenre = <any> 'cBundleGenre',
        Experiment = <any> 'experiment',
        BidOnLegacyBlockedPlacement = <any> 'bidOnLegacyBlockedPlacement',
        CampaignGroupId = <any> 'campaignGroupId',
        PidFactor = <any> 'pidFactor',
        DaysFromLastEngagement3 = <any> 'daysFromLastEngagement3',
        PastInstalls3Bucket = <any> 'pastInstalls3Bucket',
        PastAppEvents3Bucket = <any> 'pastAppEvents3Bucket',
        SourceExtStype = <any> 'sourceExtStype',
        ReallyRequest = <any> 'reallyRequest',
        CreativeMeta = <any> 'creativeMeta',
        AdMarkupActivated = <any> 'adMarkupActivated',
        IpType = <any> 'ipType',
        Tmax = <any> 'tmax',
        CreativeCompanionType = <any> 'creativeCompanionType',
        CampaignName = <any> 'campaignName',
        CampaignBundle = <any> 'campaignBundle',
        CampaignBundleName = <any> 'campaignBundleName',
        AppRatingRange = <any> 'appRatingRange',
        ConversionMode = <any> 'conversionMode',
        CreativeName = <any> 'creativeName',
        CreativeApiName = <any> 'creativeApiName',
        CreativeFormat = <any> 'creativeFormat',
        CreativeFormatRequest = <any> 'creativeFormatRequest',
        StatBundleStatus = <any> 'statBundleStatus',
        CampaignStatus = <any> 'campaignStatus',
        CampaignCreativeType = <any> 'campaignCreativeType',
        CreativeStatus = <any> 'creativeStatus',
        SegmentNames = <any> 'segmentNames',
        SegmentSplittedFull = <any> 'segmentSplittedFull',
        BundleStatCategory = <any> 'bundleStatCategory',
        BundleCountry = <any> 'bundleCountry',
        BundleOwner = <any> 'bundleOwner',
        BundleMmp = <any> 'bundleMmp',
        BundleBusinessDev = <any> 'bundleBusinessDev',
        BundleAdvertiser = <any> 'bundleAdvertiser',
        UpdatedAppVersion = <any> 'updatedAppVersion',
        Netspeed = <any> 'netspeed',
        DeviceType = <any> 'deviceType',
        Bidfloorrange = <any> 'bidfloorrange',
        Connectiontype = <any> 'connectiontype',
        Country = <any> 'country',
        CountryName = <any> 'countryName',
        StateName = <any> 'stateName',
        Protocol = <any> 'protocol',
        VastVersion = <any> 'vastVersion',
        NativeProtocol = <any> 'nativeProtocol',
        NativeVastVersion = <any> 'nativeVastVersion',
        CompanionType = <any> 'companionType',
        DisplayManagerWithVersion = <any> 'displayManagerWithVersion',
        BannerFramework = <any> 'bannerFramework',
        VideoFramework = <any> 'videoFramework',
        NativeFramework = <any> 'nativeFramework',
        DsBranch = <any> 'dsBranch',
        DsBranchVer = <any> 'dsBranchVer',
        BiddingLogicName = <any> 'biddingLogicName',
        LossReason = <any> 'lossReason',
        MonthName = <any> 'monthName',
        AudienceIdsSplittedWithName = <any> 'audienceIdsSplittedWithName',
        PacingType = <any> 'pacingType',
        Orientation = <any> 'orientation',
        DailyBudget = <any> 'dailyBudget',
        HourlyBudget = <any> 'hourlyBudget',
        CridSelectionStrategyName = <any> 'cridSelectionStrategyName',
        CridSelectionBreakdownName = <any> 'cridSelectionBreakdownName',
        BidTypeName = <any> 'bidTypeName',
        BannerPosName = <any> 'bannerPosName',
        CampaignApiName = <any> 'campaignApiName',
        SkanParameterArraySplittedCalc = <any> 'skanParameterArraySplittedCalc',
        SkanParameterArrayCalc = <any> 'skanParameterArrayCalc',
        Week = <any> 'week',
        DailyBudgetBundle = <any> 'dailyBudgetBundle',
        ReallyRequestNullFalse = <any> 'reallyRequestNullFalse',
        PlId = <any> 'plId',
        PlBundle = <any> 'plBundle',
        PlSsp = <any> 'plSsp',
        PlName = <any> 'plName',
        PlRewarded = <any> 'plRewarded',
        BundleId = <any> 'bundleId',
        BundleTitle = <any> 'bundleTitle',
        BundleOs = <any> 'bundleOs',
        BundleIcon = <any> 'bundleIcon',
        BundleRating = <any> 'bundleRating',
        BundleReviews = <any> 'bundleReviews',
        BundleAvgUserRating = <any> 'bundleAvgUserRating',
        BundleLastUpdateDate = <any> 'bundleLastUpdateDate',
        BundleDeveloperName = <any> 'bundleDeveloperName',
        BundleDownloadsNumber = <any> 'bundleDownloadsNumber',
        BundleIapAvaliable = <any> 'bundleIapAvaliable',
        BundleIapMin = <any> 'bundleIapMin',
        BundleIapMax = <any> 'bundleIapMax',
        BundleRequireLocation = <any> 'bundleRequireLocation',
        BundleStatus = <any> 'bundleStatus',
        BundleAppVer = <any> 'bundleAppVer',
        PlBundleCountry = <any> 'plBundleCountry',
        PlAppSize = <any> 'plAppSize',
        BundleGenderStatus = <any> 'bundleGenderStatus',
        BundleDescription = <any> 'bundleDescription',
        BundleCategory = <any> 'bundleCategory',
        BundleSegments = <any> 'bundleSegments',
        AeDate = <any> 'aeDate',
        AeBidTime = <any> 'aeBidTime',
        AeCampaignId = <any> 'aeCampaignId',
        AeCreativeId = <any> 'aeCreativeId',
        AeSspId = <any> 'aeSspId',
        AeIgnoreReason = <any> 'aeIgnoreReason',
        AeType = <any> 'aeType',
        AeToken = <any> 'aeToken',
        AeBidId = <any> 'aeBidId',
        AeCluster = <any> 'aeCluster',
        AeRequestUrl = <any> 'aeRequestUrl',
        AeCountry = <any> 'aeCountry',
        AeBundle = <any> 'aeBundle',
        AeBundleStartDate = <any> 'aeBundleStartDate',
        AeEventType = <any> 'aeEventType',
        AeDeviceId = <any> 'aeDeviceId',
        AeConversionMode = <any> 'aeConversionMode',
        AeProcessed = <any> 'aeProcessed',
        AeEventDeviceId = <any> 'aeEventDeviceId',
        AeRevenue = <any> 'aeRevenue',
        AeRevenueCurrency = <any> 'aeRevenueCurrency',
        SessionSpacing = <any> 'sessionSpacing',
        AeIdfv = <any> 'aeIdfv',
        AeCampaignType = <any> 'aeCampaignType',
        NaeTouchType = <any> 'naeTouchType',
        NaeSiteId = <any> 'naeSiteId',
        NaeSubSiteId = <any> 'naeSubSiteId',
        NaeCampaignName = <any> 'naeCampaignName',
        SkdnVersion = <any> 'skdnVersion',
        SkdnAdNetworkId = <any> 'skdnAdNetworkId',
        SkdnCampaignId = <any> 'skdnCampaignId',
        SkdnSourceIdentifier = <any> 'skdnSourceIdentifier',
        SkdnTransactionId = <any> 'skdnTransactionId',
        SkdnAppId = <any> 'skdnAppId',
        SkdnAttributionSignature = <any> 'skdnAttributionSignature',
        SkdnRedownload = <any> 'skdnRedownload',
        SkdnSourceAppId = <any> 'skdnSourceAppId',
        SkdnSourceDomain = <any> 'skdnSourceDomain',
        SkdnFidelityType = <any> 'skdnFidelityType',
        SkdnDidWin = <any> 'skdnDidWin',
        SkdnPostbackSequenceIndex = <any> 'skdnPostbackSequenceIndex',
        SkdnConversionValue = <any> 'skdnConversionValue',
        SkdnIp = <any> 'skdnIp',
        SkdnCountry = <any> 'skdnCountry',
        SkdnTimeReceived = <any> 'skdnTimeReceived',
        SkdnSignaturevalid = <any> 'skdnSignaturevalid',
        SkdnPostbackUrl = <any> 'skdnPostbackUrl',
        SkdnPostbackRequestBody = <any> 'skdnPostbackRequestBody',
        SkdnRequestJson = <any> 'skdnRequestJson',
        SkdnPostbackResponseStatus = <any> 'skdnPostbackResponseStatus',
        SkdnPostbackResponseBody = <any> 'skdnPostbackResponseBody',
        SkdnPostbackError = <any> 'skdnPostbackError',
        SkdnAppName = <any> 'skdnAppName',
        SkdnSourceAppName = <any> 'skdnSourceAppName',
        SkdnDate = <any> 'skdnDate',
        AapType = <any> 'aapType',
        AapTime = <any> 'aapTime',
        AapSiteId = <any> 'aapSiteId',
        AapSubSiteId = <any> 'aapSubSiteId',
        AapCid = <any> 'aapCid',
        AapCountry = <any> 'aapCountry',
        AapAdId = <any> 'aapAdId',
        AapCampaign = <any> 'aapCampaign',
        AapAdsetId = <any> 'aapAdsetId',
        AapAd = <any> 'aapAd',
        AapTransaction = <any> 'aapTransaction',
        AapPlatform = <any> 'aapPlatform',
        AapMatchType = <any> 'aapMatchType',
        AapBundle = <any> 'aapBundle',
        AapAttStatus = <any> 'aapAttStatus',
        AapAtt = <any> 'aapAtt',
        AapAppName = <any> 'aapAppName',
        AapAppIdIos = <any> 'aapAppIdIos',
        AapAppId = <any> 'aapAppId',
        AapChannel = <any> 'aapChannel',
        AapAdset = <any> 'aapAdset',
        AapAdType = <any> 'aapAdType',
        AapAdOrientation = <any> 'aapAdOrientation',
        AapActionType = <any> 'aapActionType',
        AapS2s = <any> 'aapS2s',
        AapInstallTimestamp = <any> 'aapInstallTimestamp',
        AapClickTimestamp = <any> 'aapClickTimestamp',
        AapPostbackTimestamp = <any> 'aapPostbackTimestamp',
        AapBlockedSubReason = <any> 'aapBlockedSubReason',
        AapBlockedReasonValue = <any> 'aapBlockedReasonValue',
        AapBlockedReason = <any> 'aapBlockedReason',
        AapTouchType = <any> 'aapTouchType',
        AapRtType = <any> 'aapRtType',
        AapRt = <any> 'aapRt',
        AapRejected = <any> 'aapRejected',
        AapReengagement = <any> 'aapReengagement',
        AapReattribution = <any> 'aapReattribution',
        AapPrimary = <any> 'aapPrimary',
        AapPartnerEventId = <any> 'aapPartnerEventId',
        AapEventSource = <any> 'aapEventSource',
        AapEventName = <any> 'aapEventName',
        AapCurrency = <any> 'aapCurrency',
        AapRevenue = <any> 'aapRevenue',
        AapRevenueUsd = <any> 'aapRevenueUsd',
        AapFirstEvent = <any> 'aapFirstEvent',
        DashboardBundleName = <any> 'dashboardBundleName',
        DashboardOffsetDay = <any> 'dashboardOffsetDay',
        DashboardOffsetWeek = <any> 'dashboardOffsetWeek',
        DashboardOffsetMonth = <any> 'dashboardOffsetMonth',
        RejectReason = <any> 'rejectReason',
        RejectReasonValue = <any> 'rejectReasonValue',
        RejectSubReason = <any> 'rejectSubReason'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SelectedCampaignTypeEnum {
        Lat = <any> 'Lat',
        Ua = <any> 'Ua',
        Rt = <any> 'Rt'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SelectedChannelTypeEnum {
        Mobile = <any> 'Mobile',
        Ctv = <any> 'Ctv'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CreativeGroupByEnum {
        Video = <any> 'Video',
        EndCard = <any> 'EndCard',
        NameAndTag = <any> 'NameAndTag',
        CreativeMeta = <any> 'CreativeMeta',
        DayAndCreativeMeta = <any> 'DayAndCreativeMeta',
        DayAndType = <any> 'DayAndType',
        DayAndName = <any> 'DayAndName'
    }
}
/**
 * 
 * @export
 * @interface DateRangeOptionsBean
 */
export interface DateRangeOptionsBean {
    /**
     * 
     * @type {string}
     * @memberof DateRangeOptionsBean
     */
    dateRange?: DateRangeOptionsBean.DateRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof DateRangeOptionsBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeOptionsBean
     */
    endDate?: string;
}

/**
 * @export
 * @namespace DateRangeOptionsBean
 */
export namespace DateRangeOptionsBean {
    /**
     * @export
     * @enum {string}
     */
    export enum DateRangeEnum {
        Today = <any> 'Today',
        Yesterday = <any> 'Yesterday',
        Last7Days = <any> 'Last7Days',
        Last30Days = <any> 'Last30Days',
        Last60Days = <any> 'Last60Days',
        ThisMonth = <any> 'ThisMonth',
        LastMonth = <any> 'LastMonth',
        CustomRange = <any> 'CustomRange',
        CustomRangeWithHours = <any> 'CustomRangeWithHours',
        LastHour = <any> 'LastHour',
        Last7NonAttrFullDays = <any> 'Last7NonAttrFullDays',
        Lifetime = <any> 'Lifetime',
        Past3Days = <any> 'Past3Days'
    }
}
/**
 * 
 * @export
 * @interface DeliverablesResultBean
 */
export interface DeliverablesResultBean {
    /**
     * 
     * @type {Array<DeliverablesResultRowBean>}
     * @memberof DeliverablesResultBean
     */
    rows?: Array<DeliverablesResultRowBean>;
    /**
     * 
     * @type {DeliverablesResultRowBean}
     * @memberof DeliverablesResultBean
     */
    total?: DeliverablesResultRowBean;
    /**
     * 
     * @type {Array<AppEventColumnInfo>}
     * @memberof DeliverablesResultBean
     */
    appEventColumnInfo?: Array<AppEventColumnInfo>;
    /**
     * 
     * @type {Array<DynamicColumnInfo>}
     * @memberof DeliverablesResultBean
     */
    dynamicColumnInfo?: Array<DynamicColumnInfo>;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultBean
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultBean
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultBean
     */
    totalRecords?: number;
}
/**
 * 
 * @export
 * @interface DeliverablesResultRowBean
 */
export interface DeliverablesResultRowBean {
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    day?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    week?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    month?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    bundle?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    countryFull?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    campaignTag?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    skanCid?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    skanCidParams?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    skanTargetingParameter?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    impr?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    click?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    install?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    conversions?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    reInstall?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    reEngagementInstall?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    installRate?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cvr?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    spend?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    spendOverall?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    skanRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cpi?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cpr?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ipm?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    rpm?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cpm?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cpc?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ftd?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ftdCvr?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ftdUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    targetUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    activeUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    roiLift?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DeliverablesResultRowBean
     */
    appEvents?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DeliverablesResultRowBean
     */
    dynamicColumns?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    mediaCost?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    cohortRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ftdCost?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    ftdCostOverall?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    revEvents?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    bundleTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverablesResultRowBean
     */
    bundleIconURL?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    revenueCohort?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    arpu?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverablesResultRowBean
     */
    arppu?: number;
}
/**
 * 
 * @export
 * @interface DynamicColumnInfo
 */
export interface DynamicColumnInfo {
    /**
     * 
     * @type {string}
     * @memberof DynamicColumnInfo
     */
    headerName?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicColumnInfo
     */
    valueType?: DynamicColumnInfo.ValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DynamicColumnInfo
     */
    cohortDay?: number;
    /**
     * 
     * @type {number}
     * @memberof DynamicColumnInfo
     */
    cpaMappingId?: number;
}

/**
 * @export
 * @namespace DynamicColumnInfo
 */
export namespace DynamicColumnInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum ValueTypeEnum {
        FTDCVR = <any> 'FTDCVR',
        FTDCVRCUSTOM = <any> 'FTDCVR_CUSTOM',
        FTDCVRRT = <any> 'FTDCVRRT',
        FTDCost = <any> 'FTDCost',
        CPA = <any> 'CPA',
        TargetCount = <any> 'TargetCount',
        TargetCVR = <any> 'TargetCVR',
        TargetRevenue = <any> 'TargetRevenue'
    }
}
/**
 * 
 * @export
 * @interface ForgotPasswordBean
 */
export interface ForgotPasswordBean {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordBean
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface FunnelAppEventData
 */
export interface FunnelAppEventData {
    /**
     * 
     * @type {number}
     * @memberof FunnelAppEventData
     */
    users?: number;
    /**
     * 
     * @type {string}
     * @memberof FunnelAppEventData
     */
    alias?: string;
    /**
     * 
     * @type {number}
     * @memberof FunnelAppEventData
     */
    percent?: number;
}
/**
 * 
 * @export
 * @interface FunnelResultBean
 */
export interface FunnelResultBean {
    /**
     * 
     * @type {number}
     * @memberof FunnelResultBean
     */
    installs?: number;
    /**
     * 
     * @type {Array<FunnelAppEventData>}
     * @memberof FunnelResultBean
     */
    appEvents?: Array<FunnelAppEventData>;
    /**
     * 
     * @type {string}
     * @memberof FunnelResultBean
     */
    tag?: string;
    /**
     * 
     * @type {Array<FunnelResultBean>}
     * @memberof FunnelResultBean
     */
    tagsData?: Array<FunnelResultBean>;
}
/**
 * 
 * @export
 * @interface ProvidersFileBody
 */
export interface ProvidersFileBody {
    /**
     * 
     * @type {Blob}
     * @memberof ProvidersFileBody
     */
    file: Blob;
}
/**
 * 
 * @export
 * @interface ResetPasswordBean
 */
export interface ResetPasswordBean {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBean
     */
    passwordConfirm?: string;
}
/**
 * 
 * @export
 * @interface UserPropsBean
 */
export interface UserPropsBean {
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    timezone?: UserPropsBean.TimezoneEnum;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof UserPropsBean
     */
    timezoneisDst?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<string>}
     * @memberof UserPropsBean
     */
    campaignTypes?: Array<UserPropsBean.CampaignTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    advReportType?: UserPropsBean.AdvReportTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserPropsBean
     */
    campaignChannelTypes?: Array<UserPropsBean.CampaignChannelTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    advReportChannel?: UserPropsBean.AdvReportChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    adMarkupType?: UserPropsBean.AdMarkupTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserPropsBean
     */
    bundlesWithTags?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UserPropsBean
     */
    campaignTags?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UserPropsBean
     */
    bundleToChannel?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    advViewOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    showActualSpend?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    haveAudiencesWithControlGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    haveIosBundle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    allowDataUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    showIntegrationsPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    showCpcAndCpm?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    showAdvertiserSelector?: boolean;
    /**
     * 
     * @type {Array<AdvertiserBundleInfoBean>}
     * @memberof UserPropsBean
     */
    bundles?: Array<AdvertiserBundleInfoBean>;
    /**
     * 
     * @type {boolean}
     * @memberof UserPropsBean
     */
    funnel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPropsBean
     */
    currency?: UserPropsBean.CurrencyEnum;
}

/**
 * @export
 * @namespace UserPropsBean
 */
export namespace UserPropsBean {
    /**
     * @export
     * @enum {string}
     */
    export enum TimezoneEnum {
        UTC = <any> 'UTC',
        KST = <any> 'KST',
        JST = <any> 'JST',
        EST = <any> 'EST',
        CET = <any> 'CET',
        CST = <any> 'CST',
        IST = <any> 'IST'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CampaignTypesEnum {
        Lat = <any> 'Lat',
        Ua = <any> 'Ua',
        Rt = <any> 'Rt'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdvReportTypeEnum {
        Lat = <any> 'Lat',
        Ua = <any> 'Ua',
        Rt = <any> 'Rt'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CampaignChannelTypesEnum {
        Mobile = <any> 'Mobile',
        Ctv = <any> 'Ctv'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdvReportChannelEnum {
        Mobile = <any> 'Mobile',
        Ctv = <any> 'Ctv'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdMarkupTypeEnum {
        EDIT = <any> 'EDIT',
        VIEW = <any> 'VIEW'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BundleToChannelEnum {
        Mobile = <any> 'Mobile',
        Ctv = <any> 'Ctv'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        JPY = <any> 'JPY'
    }
}
/**
 * AdvertiserAudienceFileControllerApi - fetch parameter creator
 * @export
 */
export const AdvertiserAudienceFileControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audienceFile(bean: string, file?: Blob, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling audienceFile.');
            }
            const localVarPath = `/providers/file`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvertiserAudienceFileControllerApi - functional programming interface
 * @export
 */
export const AdvertiserAudienceFileControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audienceFile(bean: string, file?: Blob, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdvertiserAudienceFileBean> {
            const localVarFetchArgs = AdvertiserAudienceFileControllerApiFetchParamCreator(configuration).audienceFile(bean, file, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdvertiserAudienceFileControllerApi - factory interface
 * @export
 */
export const AdvertiserAudienceFileControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audienceFile(bean: string, file?: Blob, options?: any) {
            return AdvertiserAudienceFileControllerApiFp(configuration).audienceFile(bean, file, options)(fetch, basePath);
        },
    };
};

/**
 * AdvertiserAudienceFileControllerApi - object-oriented interface
 * @export
 * @class AdvertiserAudienceFileControllerApi
 * @extends {BaseAPI}
 */
export class AdvertiserAudienceFileControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} bean 
     * @param {Blob} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserAudienceFileControllerApi
     */
    public audienceFile(bean: string, file?: Blob, options?: any) {
        return AdvertiserAudienceFileControllerApiFp(this.configuration).audienceFile(bean, file, options)(this.fetch, this.basePath);
    }

}
/**
 * AdvertiserControllerApi - fetch parameter creator
 * @export
 */
export const AdvertiserControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupLimitsGet(advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/providers/adv-markup-limits`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsGet(advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/providers/markups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<AdMarkupBean>} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsPost(body: Array<AdMarkupBean>, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling advMarkupsPost.');
            }
            const localVarPath = `/providers/markups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;AdMarkupBean&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advTargetEvents(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling advTargetEvents.');
            }
            const localVarPath = `/providers/target-events`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDefaultReportType(body: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling changeDefaultReportType.');
            }
            const localVarPath = `/providers/changeDefaultReportType`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePass(body: ChangePasswordBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling changePass.');
            }
            const localVarPath = `/providers/changePassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangePasswordBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTimezone(body: string, advertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling changeTimezone.');
            }
            const localVarPath = `/providers/changeTimezone`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/providers/countries`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creatives(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling creatives.');
            }
            const localVarPath = `/providers/creatives`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativesCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling creativesCsv.');
            }
            const localVarPath = `/providers/creatives-csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdvertisers(options: any = {}): FetchArgs {
            const localVarPath = `/providers/advertisers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overview(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling overview.');
            }
            const localVarPath = `/providers/overview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportFunnel(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reportFunnel.');
            }
            const localVarPath = `/providers/funnel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtml(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reportHtml.');
            }
            const localVarPath = `/providers/report-html`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtmlCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reportHtmlCsv.');
            }
            const localVarPath = `/providers/report-html-csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIntegrations(advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/providers/intergations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProps(advertiserId?: number, accountAdvertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/providers/user-props`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (accountAdvertiserId !== undefined) {
                localVarQueryParameter['accountAdvertiserId'] = accountAdvertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvertiserControllerApi - functional programming interface
 * @export
 */
export const AdvertiserControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupLimitsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdvAdMarkupLimit> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advMarkupLimitsGet(advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdMarkupBean>> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advMarkupsGet(advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<AdMarkupBean>} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsPost(body: Array<AdMarkupBean>, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdMarkupBean>> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advMarkupsPost(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advTargetEvents(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeliverablesResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).advTargetEvents(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDefaultReportType(body: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).changeDefaultReportType(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ChangePasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePass(body: ChangePasswordBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).changePass(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTimezone(body: string, advertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).changeTimezone(body, advertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CountryBean>> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).countries(advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creatives(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreativeResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).creatives(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativesCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreativeResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).creativesCsv(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdvertisers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AdvertiserOptionBean>> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).getUserAdvertisers(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overview(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeliverablesResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).overview(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportFunnel(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FunnelResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).reportFunnel(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtml(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeliverablesResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).reportHtml(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtmlCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeliverablesResultBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).reportHtmlCsv(body, advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIntegrations(advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<BundleIntegrationBean>> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).reportIntegrations(advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProps(advertiserId?: number, accountAdvertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserPropsBean> {
            const localVarFetchArgs = AdvertiserControllerApiFetchParamCreator(configuration).userProps(advertiserId, accountAdvertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdvertiserControllerApi - factory interface
 * @export
 */
export const AdvertiserControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupLimitsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).advMarkupLimitsGet(advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).advMarkupsGet(advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<AdMarkupBean>} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advMarkupsPost(body: Array<AdMarkupBean>, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).advMarkupsPost(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advTargetEvents(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).advTargetEvents(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDefaultReportType(body: string, options?: any) {
            return AdvertiserControllerApiFp(configuration).changeDefaultReportType(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ChangePasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePass(body: ChangePasswordBean, options?: any) {
            return AdvertiserControllerApiFp(configuration).changePass(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} body 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTimezone(body: string, advertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).changeTimezone(body, advertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).countries(advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creatives(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).creatives(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativesCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).creativesCsv(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAdvertisers(options?: any) {
            return AdvertiserControllerApiFp(configuration).getUserAdvertisers(options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overview(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).overview(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportFunnel(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).reportFunnel(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtml(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).reportHtml(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardReportBean} body 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHtmlCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).reportHtmlCsv(body, advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIntegrations(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).reportIntegrations(advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [advertiserId] 
         * @param {number} [accountAdvertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProps(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
            return AdvertiserControllerApiFp(configuration).userProps(advertiserId, accountAdvertiserId, options)(fetch, basePath);
        },
    };
};

/**
 * AdvertiserControllerApi - object-oriented interface
 * @export
 * @class AdvertiserControllerApi
 * @extends {BaseAPI}
 */
export class AdvertiserControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advMarkupLimitsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advMarkupLimitsGet(advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advMarkupsGet(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advMarkupsGet(advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<AdMarkupBean>} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advMarkupsPost(body: Array<AdMarkupBean>, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advMarkupsPost(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public advTargetEvents(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).advTargetEvents(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public changeDefaultReportType(body: string, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).changeDefaultReportType(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ChangePasswordBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public changePass(body: ChangePasswordBean, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).changePass(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} body 
     * @param {number} [advertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public changeTimezone(body: string, advertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).changeTimezone(body, advertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public countries(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).countries(advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public creatives(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).creatives(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public creativesCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).creativesCsv(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public getUserAdvertisers(options?: any) {
        return AdvertiserControllerApiFp(this.configuration).getUserAdvertisers(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public overview(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).overview(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public reportFunnel(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).reportFunnel(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public reportHtml(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).reportHtml(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardReportBean} body 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public reportHtmlCsv(body: DashboardReportBean, advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).reportHtmlCsv(body, advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public reportIntegrations(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).reportIntegrations(advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [advertiserId] 
     * @param {number} [accountAdvertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiserControllerApi
     */
    public userProps(advertiserId?: number, accountAdvertiserId?: number, options?: any) {
        return AdvertiserControllerApiFp(this.configuration).userProps(advertiserId, accountAdvertiserId, options)(this.fetch, this.basePath);
    }

}
/**
 * BuildInfoControllerApi - fetch parameter creator
 * @export
 */
export const BuildInfoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options: any = {}): FetchArgs {
            const localVarPath = `/build-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildInfoControllerApi - functional programming interface
 * @export
 */
export const BuildInfoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = BuildInfoControllerApiFetchParamCreator(configuration).about(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BuildInfoControllerApi - factory interface
 * @export
 */
export const BuildInfoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options?: any) {
            return BuildInfoControllerApiFp(configuration).about(options)(fetch, basePath);
        },
    };
};

/**
 * BuildInfoControllerApi - object-oriented interface
 * @export
 * @class BuildInfoControllerApi
 * @extends {BaseAPI}
 */
export class BuildInfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildInfoControllerApi
     */
    public about(options?: any) {
        return BuildInfoControllerApiFp(this.configuration).about(options)(this.fetch, this.basePath);
    }

}
/**
 * ResetPasswordControllerApi - fetch parameter creator
 * @export
 */
export const ResetPasswordControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearTokens(options: any = {}): FetchArgs {
            const localVarPath = `/providers/clearTokens`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling forgotPassword.');
            }
            const localVarPath = `/providers/forgotPassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ForgotPasswordBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordBean} body 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: ResetPasswordBean, token: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling resetPassword.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/providers/resetPassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ResetPasswordBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResetPasswordControllerApi - functional programming interface
 * @export
 */
export const ResetPasswordControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearTokens(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ResetPasswordControllerApiFetchParamCreator(configuration).clearTokens(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ForgotPasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ResetPasswordControllerApiFetchParamCreator(configuration).forgotPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ResetPasswordBean} body 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: ResetPasswordBean, token: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ResetPasswordControllerApiFetchParamCreator(configuration).resetPassword(body, token, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ResetPasswordControllerApi - factory interface
 * @export
 */
export const ResetPasswordControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearTokens(options?: any) {
            return ResetPasswordControllerApiFp(configuration).clearTokens(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ForgotPasswordBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordBean, options?: any) {
            return ResetPasswordControllerApiFp(configuration).forgotPassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ResetPasswordBean} body 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: ResetPasswordBean, token: string, options?: any) {
            return ResetPasswordControllerApiFp(configuration).resetPassword(body, token, options)(fetch, basePath);
        },
    };
};

/**
 * ResetPasswordControllerApi - object-oriented interface
 * @export
 * @class ResetPasswordControllerApi
 * @extends {BaseAPI}
 */
export class ResetPasswordControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordControllerApi
     */
    public clearTokens(options?: any) {
        return ResetPasswordControllerApiFp(this.configuration).clearTokens(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ForgotPasswordBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordControllerApi
     */
    public forgotPassword(body: ForgotPasswordBean, options?: any) {
        return ResetPasswordControllerApiFp(this.configuration).forgotPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ResetPasswordBean} body 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordControllerApi
     */
    public resetPassword(body: ResetPasswordBean, token: string, options?: any) {
        return ResetPasswordControllerApiFp(this.configuration).resetPassword(body, token, options)(this.fetch, this.basePath);
    }

}
/**
 * ShadowLoginControllerApi - fetch parameter creator
 * @export
 */
export const ShadowLoginControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tempToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shadowLogin(tempToken: string, options: any = {}): FetchArgs {
            // verify required parameter 'tempToken' is not null or undefined
            if (tempToken === null || tempToken === undefined) {
                throw new RequiredError('tempToken','Required parameter tempToken was null or undefined when calling shadowLogin.');
            }
            const localVarPath = `/shadowlogin/{tempToken}`
                .replace(`{${"tempToken"}}`, encodeURIComponent(String(tempToken)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShadowLoginControllerApi - functional programming interface
 * @export
 */
export const ShadowLoginControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tempToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shadowLogin(tempToken: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ShadowLoginControllerApiFetchParamCreator(configuration).shadowLogin(tempToken, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ShadowLoginControllerApi - factory interface
 * @export
 */
export const ShadowLoginControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} tempToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shadowLogin(tempToken: string, options?: any) {
            return ShadowLoginControllerApiFp(configuration).shadowLogin(tempToken, options)(fetch, basePath);
        },
    };
};

/**
 * ShadowLoginControllerApi - object-oriented interface
 * @export
 * @class ShadowLoginControllerApi
 * @extends {BaseAPI}
 */
export class ShadowLoginControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} tempToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowLoginControllerApi
     */
    public shadowLogin(tempToken: string, options?: any) {
        return ShadowLoginControllerApiFp(this.configuration).shadowLogin(tempToken, options)(this.fetch, this.basePath);
    }

}
/**
 * StatisticsCreativeCacheServiceControllerApi - fetch parameter creator
 * @export
 */
export const StatisticsCreativeCacheServiceControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadCache(options: any = {}): FetchArgs {
            const localVarPath = `/statistics/creative/cache/reload`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsCache(options: any = {}): FetchArgs {
            const localVarPath = `/statistics/creative/cache/stats`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsCreativeCacheServiceControllerApi - functional programming interface
 * @export
 */
export const StatisticsCreativeCacheServiceControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadCache(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = StatisticsCreativeCacheServiceControllerApiFetchParamCreator(configuration).reloadCache(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsCache(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = StatisticsCreativeCacheServiceControllerApiFetchParamCreator(configuration).statisticsCache(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StatisticsCreativeCacheServiceControllerApi - factory interface
 * @export
 */
export const StatisticsCreativeCacheServiceControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadCache(options?: any) {
            return StatisticsCreativeCacheServiceControllerApiFp(configuration).reloadCache(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsCache(options?: any) {
            return StatisticsCreativeCacheServiceControllerApiFp(configuration).statisticsCache(options)(fetch, basePath);
        },
    };
};

/**
 * StatisticsCreativeCacheServiceControllerApi - object-oriented interface
 * @export
 * @class StatisticsCreativeCacheServiceControllerApi
 * @extends {BaseAPI}
 */
export class StatisticsCreativeCacheServiceControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsCreativeCacheServiceControllerApi
     */
    public reloadCache(options?: any) {
        return StatisticsCreativeCacheServiceControllerApiFp(this.configuration).reloadCache(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsCreativeCacheServiceControllerApi
     */
    public statisticsCache(options?: any) {
        return StatisticsCreativeCacheServiceControllerApiFp(this.configuration).statisticsCache(options)(this.fetch, this.basePath);
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/base/api.ts